import "./App.css";
import { MsalAuthenticationTemplate } from "@azure/msal-react";
import {
  InteractionType,
  RedirectRequest,
} from "@azure/msal-browser";
import { loginRequest } from "@api/msal";
import { RouterProvider } from "react-router";
import router from "./routes";
import '@styles/main.scss';
import AppLoader from "@components/AppLoader/AppLoader";
import { ConfigProvider } from 'antd';
import ThemeProvider from "@components/ThemeProvider/ThemeProvider";
import { selectOrganisationTheme } from "@selectors/organisationSelector";
import { useSelector } from "react-redux";
import { selectOrganisationContextId } from "@selectors/appSelector";
import dayjs from "dayjs";
import updateLocale from "dayjs/plugin/updateLocale";
import isoWeek from "dayjs/plugin/isoWeek";
import { isE2EWithoutSso } from "./e2e/e2eAuth";

dayjs.extend(isoWeek);
dayjs.extend(updateLocale);
const lang = navigator.language.toLowerCase(); 
dayjs.locale(lang.startsWith("pl") ? "pl" : "en");
dayjs.updateLocale(dayjs.locale(), { weekStart: 1 });

function App() {

  const authenticationRequest: RedirectRequest = {
    ...loginRequest,
    state: JSON.stringify({ redirectTo: window.location.pathname }),
  };

  const organisationId = useSelector(selectOrganisationContextId);
  const theme = useSelector(selectOrganisationTheme(organisationId));
  const controlTextColor = theme?.question_text_color ?? "#171542";

  const appContent = (
    <>
      <ThemeProvider>
        <ConfigProvider
          theme={{
            components: {
              DatePicker: {
                colorPrimary: theme?.secondary_color ?? "#171542",
                cellActiveWithRangeBg: theme?.primary_color ?? "#ffd300",
                cellHoverWithRangeBg: theme?.secondary_color ?? "#ffd300",
                cellRangeBorderColor: theme?.primary_color ?? "#ffd300",
                colorText: theme?.secondary_color ?? "#171542",
                colorTextHeading: theme?.secondary_color ?? "#171542",
                cellHoverBg: theme?.secondary_color ?? "#171542",
                activeBorderColor: theme?.secondary_color ?? "#171542",
                hoverBorderColor: theme?.secondary_color ?? "#171542",
                colorBgBase: theme?.secondary_color ?? "#171542",
              },
              Select: {
                colorBorder: theme?.secondary_color ?? "#171542",
                colorPrimary: theme?.secondary_color ?? "#171542",
                colorPrimaryHover: theme?.primary_color ?? "#ffd300",
                optionSelectedBg: theme?.secondary_color ?? "#171542",
                optionSelectedColor: theme?.primary_color ?? "#ffd300",
                colorText: controlTextColor,
                colorTextPlaceholder: controlTextColor,
              },
              Pagination: {
                colorText: controlTextColor,
              },
            },
          }}>
          <AppLoader>
            <RouterProvider router={router} />
          </AppLoader>
        </ConfigProvider>
      </ThemeProvider>
    </>
  );

  if (isE2EWithoutSso) {
    return appContent;
  }

  return (
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      authenticationRequest={authenticationRequest}
    >
      {appContent}
    </MsalAuthenticationTemplate >
  );
}

export default App;
